var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28.391357px",
    height: "29.022217px",
    viewBox: "0 0 28.391357 29.022217",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L28.3913 0L28.3913 29.0222L0 29.0222L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L28.3913 0L28.3913 29.0222L0 29.0222L0 0Z",
    id: "Background",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.54895 1.74134C3.54895 0.779516 4.31152 0 5.25243 0L17.7446 0L24.8425 6.09465L24.8425 27.2809C24.8425 28.2427 24.0799 29.0222 23.139 29.0222L5.25243 29.0222C4.31152 29.0222 3.54895 28.2427 3.54895 27.2809L3.54895 1.74134L3.54895 1.74134Z",
    id: "Shape",
    fill: "#D22600",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7446 0L17.7446 4.35331C17.7446 5.31514 18.5072 6.09465 19.4481 6.09465L24.8425 6.09465",
    id: "Shape",
    fill: "#AC2200",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.5150146 13.701294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.13865 4.20004L1.47323 4.20004L1.47323 6.28647L0 6.28647L0 0L1.94345 0C3.62078 0 4.57895 0.671167 4.57895 2.05012C4.57854 3.52935 3.59373 4.20004 2.13865 4.20004L2.13865 4.20004ZM1.95984 1.07016L1.47189 1.07016L1.47189 3.11125L2.0131 3.11125C2.67852 3.11125 3.06001 2.78428 3.06001 2.04969C3.06001 1.38804 2.69625 1.07016 1.95984 1.07016L1.95984 1.07016Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81638 6.28647L4.14795 6.28647L4.14795 0L5.70991 0C7.29008 0 8.7979 0.516987 8.7979 3.11216C8.79796 5.66885 7.3513 6.28647 5.81638 6.28647L5.81638 6.28647ZM5.92149 1.08838L5.61984 1.08838L5.61984 5.1982L5.92149 5.1982C6.7289 5.1982 7.27006 4.75379 7.27006 3.11134C7.27094 1.43396 6.69384 1.08838 5.92149 1.08838L5.92149 1.08838Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4492 1.07017L12.4492 2.72171L14.5968 2.72171L14.5968 3.80097L12.4492 3.80097L12.4492 6.28647L10.9671 6.28647L10.9671 0L15.0226 0L14.8718 1.07017L12.4492 1.07017L12.4492 1.07017L12.4492 1.07017Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.2739ea9a45856cd68236519bbf105245.svg";
export { ForwardRef as ReactComponent };